import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'
// import { responsiveImageFragment } from '../fragments/images'

export const privacyPage = gql`
  ${seoFragment}
  query PrivacyPage($locale: SiteLocale) {
    privacy(locale: $locale) {
      seo {
        ...SeoFragment
      }
      _allSlugLocales {
        value
        locale
      }
      titolo
      slug
      testo
    }
  }
`
